import { defineComponent } from 'vue';
import SearchDropdownItemCode
	from '@/presentation/components/organisation-linking/organisation-linking-search/search-dropdown-item/search-dropdown-item.code';

export default defineComponent({
	props: {
		name: {
			type: String,
			required: true
		},
		id: {
			type: Number,
			required: true
		}
	},
	setup: (props) => {
		const code = new SearchDropdownItemCode(
			props.name,
			props.id
		);

		return {
			name: props.name,
			id: props.id,
			onClick: code.onClick.bind(code)
		};
	}
});
